import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LOCALE } from '../../constants';

export const sliderTutorialMessagesApi = createApi({
  reducerPath: 'sliderTutorialMessagesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api_no_auth/holiday_finder'
  }),
  tagTypes: ['SliderTutorialMessages'],
  endpoints: builder => ({
    getSliderTutorialMessages: builder.query({
      query: () => `/tutorial-msgs/?locale=${LOCALE}`,
      providesTags: ['SliderTutorialMessages'],
    }),
  })
});

export const {
  useGetSliderTutorialMessagesQuery,
} = sliderTutorialMessagesApi;
